//Sarada : 10-10-2022
import { FAQs_GET_LIST,FAQs_GET_LIST_SUCCESS,FAQs_GET_LIST_ERROR } from "../../../redux/contants";

const INIT_STATE = {
    getfaqsList: [],
    loading: false,
    error: '',
    messages: ''
};
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FAQs_GET_LIST:
            // alert(action.type)
            // alert(action.data)
            return { ...state, loading: true, error: '' };
        case FAQs_GET_LIST_SUCCESS:
            console.log('FAQs_GET_LIST_SUCCESS===',action);
            return {
                ...state,
                loading: false,
                getfaqsList: action.data,
                error: '',
                messages: ''
            };
        case FAQs_GET_LIST_ERROR:
            return {
                ...state,
                loading: false,
                getfaqsList: [],
                error: action.error,
                messages: ''
            };
        default:
            return { ...state };
    }
};
